import { Typography } from "@mui/material";
import React from "react";
import { chartAccrdionHandler } from "../../../../utils/DashboardAccrdionHandler";
import { useDashboardSettings } from "../../../../Context/DashboardSettingProvider";

function TitleChart({ label, chartKey }) {
  const { updateAccrdion, dashboardAccrdion } = useDashboardSettings();
  return (
    <Typography
      color={"rgba(30, 106, 253, 1)"}
      sx={{ ":hover": { cursor: "pointer" } }}
      onClick={() =>
        chartAccrdionHandler(chartKey, dashboardAccrdion, updateAccrdion)
      }
    >
      {label}
    </Typography>
  );
}

export default TitleChart;
